import React, {FunctionComponent} from 'react';
import {Redirect, useLocation} from 'react-router-dom';
import {useOktaAuth} from '@okta/okta-react';

import './Login.scss';
import logoImage from 'assets/img/icon_circle-cfa-logo.svg';
import {Button} from 'cfa-react-components';
import {oktaScopes} from 'App';

interface ILoginProps {}

export const Login: FunctionComponent<ILoginProps> = function() {
    const {oktaAuth, authState} = useOktaAuth();
    const location = useLocation<{error?: string}>();

    // Redirect to home if we're authenticated
    if (authState.isAuthenticated) {
        return <Redirect to={'/home'} />
    }
    
    // Check for an error message in our location state. We'll get passed one if login failed.
    const error = location.state?.error;
    if (error) {
        // Clear the error from browser history so that if the user refreshes, it goes away.
        // This doesn't modify react's in-memory location state, so rerenders will still show the error.
        window.history.replaceState({}, document.title);
    }

    const login = () => {
        oktaAuth.signInWithRedirect({
            scopes: oktaScopes,
        });
    }

    return (
        <div className="login_container">
            <div className="login_widget">
                <div className="login_widgetHeader">
                    <img className="login_logo" src={logoImage} />
                    <h1 className="login_headerText">
                        {'SmartEquip MQTT CapRep'}
                    </h1>
                </div>
                <div className="login_widgetBody">
                    <div>
                        <Button onClick={login}>
                            {'Sign In'}
                        </Button>
                    </div>
                    <div>
                        <a href={process.env.REACT_APP_OKTA_BASE_URL} className="login_manageAccount">
                            {'Manage Account'}
                        </a>
                    </div>
                    {error && (<>
                        <div className="login_error">
                            {error}
                        </div>
                    </>)}
                </div>
            </div>
        </div>
    );
}